import React, { Fragment, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { Slider, Row, Col, Icon } from '@/elements';
import { Button } from '@/elements';
import moment from 'moment';

const COMPONENT_CSS_CLASSNAME = 'evacuation-evacuation-playerBar';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

const formatTime = val => moment(val, 'x').format('HH:mm:ss');
const getFormatedSec = sec =>
	moment()
		.startOf('day')
		.seconds(sec)
		.format('HH:mm:ss');
const getNowTime = (start, val) =>
	moment(start, 'x')
		.add(val, 'seconds')
		.format('HH:mm:ss');
const formatTimeDiff = (start, end) => {
	const sec = moment(end, 'x').diff(moment(start, 'x'), 'seconds');
	return moment()
		.startOf('day')
		.seconds(sec)
		.format('HH:mm:ss');
};

const handlePlayPause = (isPaused, onStart, onPause, onResume) => {
	if (isPaused) {
		onResume();
	} else {
		onPause();
	}
};

const EvacuationPlayerBar = React.memo(
	({
		onChange,
		onAfterChange,
		type,
		replayTimeline: { start, end, sec, formatSec },
		now,
		isPaused,
		onStart,
		onResume,
		onPause,
		onSpeed,
		currentSpeed,
	}) => {
		function handleShift(hold) {
			if (hold) {
				onPause();
			} else {
				onResume();
			}
		}
		// call back to mount slider, when drag slider handler set pause and unpause after mouse up
		const cbRef = useCallback(node => {
			if (node !== null) {
				const target = document.getElementsByClassName(
					'ant-slider-handle',
				)[0];
				const wrapper = document.getElementsByClassName(
					'slider_wrap',
				)[0];
				target.addEventListener('mousedown', () => handleShift(true));
				wrapper.addEventListener('mouseup', () => handleShift(false));
				return () => {
					target.removeEventListener('mousedown', () =>
						handleShift(true),
					);
					wrapper.removeEventListener('mouseup', () =>
						handleShift(false),
					);
				};
			}
		}, []);

		return type === 'replay' ? (
			<Row
				type="flex"
				align="middle"
				gutter={8}
				className={COMPONENT_CSS_CLASSNAME}
			>
				<Col xs={4} md={2}>
					<Button
						type="primary"
						block
						onClick={() =>
							handlePlayPause(
								isPaused,
								onStart,
								onPause,
								onResume,
							)
						}
					>
						{isPaused === null || isPaused ? (
							<Icon type="caret-right" />
						) : (
							<Icon type="pause" />
						)}
					</Button>
				</Col>
				<Col xs={16} md={20} style={{ padding: '5px 0' }}>
					<div className="slider_wrap">
						<div className="slider_mark start">
							{formatTime(start)}
							<span>00:00:00</span>
						</div>
						<div className="slider_mark end">
							{formatTime(end)}
							<span>{formatSec}</span>
						</div>
						<Slider
							ref={cbRef}
							min={0}
							max={sec}
							// step={currentSpeed}
							// tooltipVisible={false}
							// disabled={isPaused}
							defaultValue={now}
							value={now}
							onChange={onChange}
							onAfterChange={onAfterChange}
							tipFormatter={val => (
								<div>
									<b>{getNowTime(start, val)}</b>
									<span>{getFormatedSec(val)}</span>
								</div>
							)}
						/>
					</div>
				</Col>
				<Col xs={4} md={2}>
					<Button
						type="primary"
						block
						onClick={() => onSpeed(currentSpeed)}
						disabled={isPaused}
					>
						{currentSpeed}X
					</Button>
				</Col>
			</Row>
		) : null;
	},
);

EvacuationPlayerBar.defaultProps = {
	percents: 0,
	employeesSave: 0,
	employeesStart: 0,
	isActive: false,
};

EvacuationPlayerBar.propTypes = {
	percents: PropTypes.number,
	employeesSave: PropTypes.number,
	employeesStart: PropTypes.number,
	isActive: PropTypes.bool,
};

export default EvacuationPlayerBar;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-player-bar/index.js